import {
  Box,
  BoxProps,
  PaperProps,
  createPolymorphicComponent,
} from "@mantine/core";
import { forwardRef, ReactNode } from "react";

type SurfaceProps = { children: ReactNode } & BoxProps & PaperProps;

export const Surface = createPolymorphicComponent<"div", SurfaceProps>(
  // eslint-disable-next-line react/display-name
  forwardRef<HTMLDivElement, SurfaceProps>(({ children, ...others }, ref) => (
    <Box component="div" {...others} ref={ref}>
      {children}
    </Box>
  ))
);

Surface.displayName = "Surface";
